"use client"

import "./css/footer.css"
import footerImage from "../img/footer.png"

const FooterSection = () => {
  return (
    <section className="footer-section" id="Footer">
      <div className="footer-content">
        <div className="footer-image-container">
          <img
            src={footerImage || "/placeholder.svg?height=400&width=400&query=footer image"}
            alt="Footer"
            className="footer-image"
          />
        </div>
        <div className="footer-text-container">
          <div>
            <h2 className="footer-text">Haz tu pedido hoy mismo</h2>
            <a
              href="https://wa.me/50230544755?text=Hola%20escribo%20de%20la%20p%C3%A1gina%20web%20quiero%20m%C3%A1s%20informaci%C3%B3n"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-whatsapp-button"
            >
              Click aquí
            </a>
          </div>
        </div>
        <div className="footer-contact-container">
          <div className="footer-contact-info">
            <div className="footer-phone-numbers">
              <p className="footer-contact-label">Números:</p>
              <a href="tel:+50258013049" className="footer-phone-link">
                58013049
              </a>
              <span className="footer-phone-separator">, </span>
              <a href="tel:+50230544755" className="footer-phone-link">
                30544755
              </a>
            </div>
            <div className="footer-address">
              <p className="footer-contact-label">Dirección:</p>
              <p className="footer-address-text">3 AVE. 1-97 zona 2 El Ceibal, villa canales, Guatemala</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FooterSection
